module.exports = __webpack_public_path__ + "static/product5-d-56dca49259e74ca6616d0b42a4cf8872.png";